import type { TimeMapping } from "../api/types";

export function streamSegment(mapping: TimeMapping | undefined, ns: number) {
  const segments = mapping?.segments;
  if (!segments?.length) return { a: 1, b: 0, start_ns: 0, end_ns: null };
  return segments.find(s => ns >= s.start_ns && (s.end_ns == null || ns < s.end_ns))
    ?? (ns < segments[0].start_ns ? segments[0] : segments[segments.length - 1]);
}
export function streamToSession(mapping: TimeMapping | undefined, ns: number) {
  const s = streamSegment(mapping, ns);
  return Math.round(s.a * ns + s.b);
}
export function sessionToStream(mapping: TimeMapping | undefined, ns: number) {
  const segments = mapping?.segments;
  if (!segments?.length) return ns;
  const s = segments.find(s => ns >= s.a * s.start_ns + s.b && (s.end_ns == null || ns < s.a * s.end_ns + s.b))
    ?? (ns < segments[0].a * segments[0].start_ns + segments[0].b ? segments[0] : segments[segments.length - 1]);
  return (ns - s.b) / s.a;
}
